var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab"},_vm._l((_vm.data),function(item){return _c('div',{key:item.label,class:['tab-item', { active: _vm.value === item.value }],on:{"click":function($event){return _vm.onClickItem(item.value)}}},[_vm._v(_vm._s(item.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }